export const FOLDER_GROUPS = "/api/folder-groups"
export const FOLDER_GROUP = "/api/folder-groups/:param"

export const FOLDER_GROUP_APPOINTMENTS = "/api/folder-groups/:param/appointments"
export const FOLDER_GROUP_APPOINTMENT = "/api/folder-groups/:param/appointments/:appointmentParam"

export const FOLDER_GROUP_DEACTIVATE = "/api/folder-groups/:param/deactivate"
export const FOLDER_GROUP_ACTIVATE = "/api/folder-groups/:param/activate"
export const EXPORT_GROUP_FOLDERS = "/api/folder-groups/export"
export const IMPORT_GROUP_FOLDERS = "/api/folder-groups/import"

export const DOWNLOAD_EVENT = "/api/events/:param/print"

export const SKILLS_EVALUATION = "/api/folder-groups/:param/skills-evaluations/:appointmentParam"
export const DOWNLOAD_SCHEDULE = "/api/folder-groups/:param/schedules"
